import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=e3d16298&scoped=true&"
import script from "./ContactsView.vue?vue&type=script&lang=js&"
export * from "./ContactsView.vue?vue&type=script&lang=js&"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=e3d16298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d16298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3d16298')) {
      api.createRecord('e3d16298', component.options)
    } else {
      api.reload('e3d16298', component.options)
    }
    module.hot.accept("./ContactsView.vue?vue&type=template&id=e3d16298&scoped=true&", function () {
      api.rerender('e3d16298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/components/ContactsView.vue"
export default component.exports